import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "reload",
  "use": "reload-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"reload\"><title>reload</title><path d=\"M17 5l.3.42h-2.17a.7.7 0 0 0 0 1.39h4.17a.7.7 0 0 0 .7-.7V2.3a.7.7 0 1 0-1.39 0v2.56l-.48-.67A10 10 0 1 0 20 10a.7.7 0 1 0-1.39 0A8.62 8.62 0 1 1 17 5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/reload.svg
// module id = hGTH
// module chunks = 6